import { types } from "../types";
import isBoolean from "lodash/isBoolean";
import has from "lodash/has";

export interface IFreeSpinsState {
  enabled?: boolean;
  value?: number;
}

export const defaultState: IFreeSpinsState = {
  enabled: false,
  value: null
};

export const freeSpins = (state = defaultState, action) => {
  if (action.type === types.SET_STATE && has(action.value, "freeSpins")) {
    const { freeSpins = {} } = action.value;
    let { enabled, value } = freeSpins ?? state;

    enabled = isBoolean(enabled) ? enabled : state.enabled;
    value = Number.isInteger(value) && value >= 0 ? value : state.value;

    return {
      ...state,
      enabled,
      value
    };
  } else {
    return state;
  }
};
